<template>
  <v-card class="ma-3">
    <v-card-title>
      Tools
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col>
          <v-btn @click="getIdToken">
            Get ID Token
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-textarea
            v-model="idToken"
            label="ID Token"
            outlined
            readonly
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapActions, mapState } = createNamespacedHelpers('develop')

export default {
  name: 'DevTools',
  computed: {
    ...mapState({
      idToken: (state) => state.idToken,
    }),
  },
  methods: {
    ...mapActions(['getIdToken']),
  },
}
</script>
